

export const _derivat_terkk_modul_ukrucenje_limcustom_bundleDraftel_make = () => {
  /*
  Naziv: Ukrućenje sekcija
  Broj komada: 4*količina komore
  Dim1: 120
  Dim2: 120
  Razvijena1: 176
  Razvijena2:176
  CNC crtez: P01-00-07-A
  Operacija1: Probijanje
  Radni centar1: Amada
  Operacija 2: Savijanje
  Radni centar2 :Ermaksan
  materijal: LB00000J-Lim pocinkovani 1.5
  */
  const bundleDraftel = {
    _draftelschemakey: 'terkk$_bundle_limcustom',
    _subform_arr: [
      {
        tempkey: -1,
        //
        identmaterijala: 'LB00000J',
        termaterijal: null,
        naziv: 'Ukrućenje sekcija',
        sirina: 120,
        duzina: 120,
        povrsina: (176 * 176) / 1000000, // (sirina * duzina) / 1000000; // konvertovana u m2
        kolicina: 4, // 4 u svaki modul ide (to je zapravo 8 jer se proizvodi dva odjednom)
        cnccrtez: 'P01-00-07-A',
        "terkategorija": "PP",
        "tergrupa": "LIM",
        operacija1: "OPSEC", //
        rc1: "RCPRBAM", //
        operacija2: "OPSAV", //
        rc2: "RCPRSER", //
        naziv_materijala: 'LIM POCINKOVANI 1.50',
      },
    ]
  };
  return bundleDraftel;
};


export const _derivat_terkk_modul_nosaci_za_klocne_limcustom_bundleDraftel_make = (virtel) => {
  /*
  Naziv: Nosači za klocne 4 kom
  CNCprogram: P01-00-14-A-4kom
  Materijal: LB00000J-LIM POCINKOVANI 1.50
  Debljina: 1.5m
  Količina:
  IF modul_vrsta_pakovanja="KLOCNA" THEN 1*Količina komora ELSE 0
  Radni centar: Probijačica amada
  Operacija1: Savijanje Ermaksan
  Razvijena mera dužina: 375
  Razvijena Širina: 142
  Površina 0,21
  */
  let kolicina = virtel.kolicina; // TODO ???
  const bundleDraftel = {
    _draftelschemakey: 'terkk$_bundle_limcustom',
    _subform_arr: [
      {
        tempkey: -2,
        //
        identmaterijala: 'LB00000J',
        termaterijal: null,
        naziv: 'Nosači za klocne 4 kom',
        sirina: 142,
        duzina: 375,
        povrsina: (142 * 375) / 1000000, // (sirina * duzina) / 1000000; // konvertovana u m2
        kolicina: kolicina, //
        cnccrtez: 'P01-00-14-A-4kom',
        "terkategorija": "PP",
        "tergrupa": "LIM",
        operacija1: "OPSEC", //
        rc1: "RCPRBAM", //
        operacija2: "OPSAV", //
        rc2: "RCPRSER", //
        naziv_materijala: 'LIM POCINKOVANI 1.50',
      },
    ]
  };
  return bundleDraftel;
};

